// import useApi from "hooks/use_api"

const useScheduledReminders = _eventId => {
  // return useApi({
  //   path: `events/${eventId}/scheduled_reminders`,
  //   data: { fields: { ScheduledReminder: "id" } }
  // })

  return {
    loading: false,
    errors: null,
    response: []
  }
}

export default useScheduledReminders
